import { Box, Checkbox, CheckboxProps, useTheme } from "@mui/material";

export const KaziCheckbox = (props: CheckboxProps) => {
    const theme = useTheme();
    return (
        <>
            <Box 
                position={"absolute"}
            >
                <Box 
                    bgcolor={props.checked ? theme.palette.primary.main : ""}
                    position={"relative"}
                    left={"13px"}
                    width={"16px"}
                    height={"16px"}
                >
                </Box>
            </Box>
            <Checkbox {...props} />
        </>
    )
}